import requests from '../../../request'

const baseUrl = '/order/retail';
const ContentTypeEnum = {
    // json
    JSON: 'application/json;charset=UTF-8',
}

/**
 * 零售订单列表
 * @param {Object} data { orderNo, merchId, retailType, lifecycleStatus, startTime, endTime, pageIndex, pageSize }
 */
export function queryList(data) {
    return requests(
        {
            url: baseUrl + '/list',
            data,
            method: 'post'
        },
        {
            contentType: ContentTypeEnum.JSON,
        },
    );
}

/**
 * 零售订单详情
 * @param {String} orderId 订单ID
 */
export function queryDetail(orderId) {
    return requests(
        {
            url: baseUrl + '/' + encodeURIComponent(orderId),
            method: 'get'
        },
    );
}

/**
 * 导出零售订单
 */
export function exportList(data) {
    return requests(
        {
            url: baseUrl + '/export',
            data,
            method: 'post',
            responseType: 'blob'
        },
        {
            contentType: ContentTypeEnum.JSON,
        },
    );
}
